// Entity owner verification link (#1356 review low 5). Same pattern as the
// joint co-sign link (#1358): the single-use emailed token rides in the URL
// fragment (/entity-owner-verification#t=...), which browsers never send to
// a server. It is moved out of the address bar before analytics or error
// reporting start, kept in this tab's sessionStorage so a reload (or coming
// back after signing in) still works, and sent to the API in a POST body,
// never in an API URL.
import { takeTokenFromLocation } from "@/utils/jointCosigner";

const TOKEN_STORAGE_KEY = "invown:entity-owner-token";
const PAGE_PATH = /\/entity-owner-verification\/?$/;

function remember(win, token) {
  try {
    win.sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
  } catch (error) {
    // Storage blocked: keep it in memory for this page load.
    win.__invownEntityOwnerToken = token;
  }
}

// Called first thing in main.js, on the owner page only.
export function captureEntityOwnerTokenEarly(win = typeof window !== "undefined" ? window : null) {
  if (!win || !win.location || !PAGE_PATH.test(win.location.pathname || "")) {
    return;
  }
  const token = takeTokenFromLocation(win);
  if (token) remember(win, token);
}

// The token for the owner page: from the fragment if still there, else
// from what main.js captured.
export function readEntityOwnerToken(win = typeof window !== "undefined" ? window : null) {
  if (!win) return "";
  const fromHash = takeTokenFromLocation(win);
  if (fromHash) {
    remember(win, fromHash);
    return fromHash;
  }
  try {
    const stored = win.sessionStorage.getItem(TOKEN_STORAGE_KEY);
    if (stored) return stored;
  } catch (error) {
    // fall through
  }
  return win.__invownEntityOwnerToken || "";
}

export function forgetEntityOwnerToken(win = typeof window !== "undefined" ? window : null) {
  if (!win) return;
  try {
    win.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
  } catch (error) {
    // nothing stored
  }
  win.__invownEntityOwnerToken = "";
}
